import * as React from 'react';
import FinancialFilingDataGrid from './FinancialFilingDataGrid';

function EightKFilings({filings} :any) {
  return (
    <div className="col-lg-4 grid-margin stretch-card">
      <div className="card">
        <div className="card-body">
          <h4 className="card-title">8-K Filings</h4>
          <p className="card-description">
            Select a 8-K (Unscheduled important events) to analyze and review with our AI assistant.
          </p>
          <div>
            { filings?.data['8-K']?.length > 0  ?
              <FinancialFilingDataGrid
                data={filings.data['8-K']}
              />
            : <p className="card-description">There are no 8-K filings available</p> }
          </div>
        </div>
      </div>
    </div>
  );
}

export default EightKFilings;
